/**
 * Máscara de telefone BR com tratamento de autofill internacional.
 *
 * O autofill do browser preenche "+55 31 99999-9999"; sem tratamento, o "55"
 * do código do país entrava como DDD e os 2 últimos dígitos eram cortados —
 * telefone errado no CRM e lead perdido pro comercial.
 *
 * Só removemos o "55" quando há MAIS de 11 dígitos: DDD 55 existe (região de
 * Santa Maria-RS) e um número local "(55) 9xxxx-xxxx" tem exatamente 11
 * dígitos, então não é afetado.
 */
export function formatPhone(value: string): string {
  let digits = value.replace(/\D/g, "");
  if (digits.length > 11 && digits.startsWith("55")) digits = digits.slice(2);
  digits = digits.slice(0, 11);
  if (digits.length <= 2) return digits.length ? `(${digits}` : "";
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
